import React from "react";
import { RequestBox } from "src/components/FeedContainer";
import { TasksTableRow } from "../types";
import { ConnectionTypeIconWithHoverTip } from "src/components/Icons";
import { normaliseIdColumnValue } from "src/components/Premises/helpers";
import { useTasksNavigation } from "../hooks";
import { UnreadMessageIcon } from "src/components/Projects/Icons";

export const TaskBox = ({ row }: { row: TasksTableRow }) => {
  const { handleOnClick } = useTasksNavigation(row);
  const primaryIcon = React.useMemo(
    () => (
      <ConnectionTypeIconWithHoverTip
        type={row.connectionType}
        state={row.state}
      />
    ),
    [row.connectionType, row.state]
  );

  const secondaryText = React.useMemo(
    () =>
      normaliseIdColumnValue(
        row.id,
        row.journeyId,
        row.distributorApplicationId
      ),
    [row.id, row.journeyId, row.distributorApplicationId]
  );

  const secondaryIcon = React.useMemo(() => {
    switch (row.taskStatus) {
      case "envelope":
        return <UnreadMessageIcon />;
      default:
        return null;
    }
  }, [row.taskStatus]);

  return (
    <RequestBox
      primaryIcon={primaryIcon}
      primaryText={row.address}
      secondaryIcon={secondaryIcon}
      secondaryText={secondaryText}
      summaryText={row.taskStatusText}
      onClick={handleOnClick}
      data-id={`taskBox.${row.id}`}
    />
  );
};
